export default [
  {
    path: '/message/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'message',
        component: () => import('@/views/Message/Message.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        }
      },
      {
        path: '/messageView/:id',
        name: 'messageView',
        component: () => import('@/views/Message/MessageReply.vue'),
        meta: {
          prev: 'message'
        }
      },
      {
        path: '/messageReply/:id',
        name: 'messageReply',
        component: () => import('@/views/Message/MessageReply.vue'),
        meta: {
          prev: 'message'
        }
      }
    ]
  }
]
